
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/smart-chains/tutorials/running-komodo-software-in-debug-mode",
      function () {
        return require("private-next-pages/docs/smart-chains/tutorials/running-komodo-software-in-debug-mode/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/smart-chains/tutorials/running-komodo-software-in-debug-mode"])
      });
    }
  